import { motion } from 'framer-motion';
import { fadeUp, stagger } from './motionPresets';

const securityItems = [
  { icon: '/icon-secure-storage.svg', title: 'Secure Document Storage', desc: 'Enterprise grade cloud storage with encryption at rest in transit' },
  { icon: '/icon-role-access.svg', title: 'Role-Based Access', desc: 'Admin, HR Manager and Viewer roles ensure the right people see the right data' },
  { icon: '/icon-audit-logs.svg', title: 'Complete Audit Logs', desc: 'Every Action tracked with user, timestamps and details for compliance audits' },
  { icon: '/icon-data-privacy.svg', title: 'Data Privacy', desc: 'SOC 2 Compliant infrastructure. Your data never shared with third parties' },
];

export default function SecuritySection() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left — Title + Image */}
          <motion.div {...fadeUp} transition={{ duration: 0.5 }}>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0F172A] tracking-tight mb-4">Enterprise-grade security</h2>
            <p className="text-lg text-[#64748B] leading-relaxed mb-10">Your Compliance data deserves the <span className="font-bold text-[#0F172A]">highest level of protection</span></p>
            <img src="/security-lock.png" alt="Enterprise security" className="w-full max-w-lg" />
          </motion.div>

          {/* Right — Security Features */}
          <motion.div {...fadeUp} transition={{ duration: 0.5, delay: 0.2 }} className="space-y-10 lg:pt-8">
            {securityItems.map((s, i) => (
              <motion.div key={s.title} {...stagger} transition={{ duration: 0.4, delay: i * 0.1 }} className="flex items-start gap-5">
                <div className="flex-shrink-0">
                  <img src={s.icon} alt={s.title} className="w-14 h-14" />
                </div>
                <div>
                  <h4 className="text-base font-bold text-[#0F172A] mb-1.5">{s.title}</h4>
                  <p className="text-sm text-[#64748B] leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
